export default "__VITE_ASSET__DimoPzKS__"